import React from "react";
import { Badge } from "react-bootstrap";

const CommonStatus = (status) => {
  if (status === "OPEN") {
    return <Badge bg="danger">SO Approval Pending</Badge>;
  } else if (status === "SO_HALF_APPROVAL") {
    return <Badge bg="success">SO Partially Approved</Badge>;
  } else if (status === "SO_APPROVED" || status === "SO_FULL_APPROVAL") {
    return <Badge bg="success">SO Approved</Badge>;
  } else if (status === "WH_APPROVED") {
    return <Badge bg="danger">Store Pending</Badge>;
  } else if (status === "AC_APPROVED") {
    return <Badge bg="success">Accounts Approved</Badge>;
  } else if (status === "ST_APPROVED") {
    return <Badge bg="danger">Pending for Dispatch</Badge>;
  } else if (status === "HALF_DISPATCH") {
    return <Badge bg="danger">Pending for Full Dispatch</Badge>;
  } else if (status === "DISPATCHED") {
    return <Badge bg="danger">In-transit</Badge>;
  } else if (status === "DELIVERED") {
    return <Badge bg="success">Inward completed</Badge>;
  } else if (status === "REJECTED") {
    return <Badge bg="danger">Rejected</Badge>;
  } else if (status === "CANCELLED") {
    return <Badge bg="danger">Cancelled</Badge>;
  } else if (status === "RETURN" || status === "RETURNED") {
    return <Badge bg="danger">Order Returned</Badge>;
  } else if (status === "REPLACE") {
    return <Badge bg="danger">Order Replaced</Badge>;
  } else if (status === "REPLACE_REQUEST") {
    return <Badge bg="danger">Order Replace Request</Badge>;
  } else if (status === "WH_PENDING") {
    return <Badge bg="success">WH Approval Pending</Badge>;
  } else if (status === "CANCELLED_REQUEST") {
    return <Badge bg="danger">Cancelled Request</Badge>;
  } else if (status === "RETURN_REQUEST") {
    return <Badge bg="danger">Return Request</Badge>;
  } else if (status === "PARTIALLY_RETURN") {
    return <Badge bg="danger">Partially Return</Badge>;
  } else if (status === "PARTIALLY_REPLACE") {
    return <Badge bg="danger">Partially Replace</Badge>;
  } else if (status === "RETURN_IN_TRANSIT") {
    return <Badge bg="danger">Return In Transit</Badge>;
  } else if (status === "INVOICE_PENDING") {
    return <Badge bg="danger">Invoice Pending</Badge>;
  } else if (status === "UC_UPCOMING") {
    return <Badge bg="danger">Upcoming Orders</Badge>;
  } else if (status === "PAYMENT_PENDING") {
    return <Badge bg="danger">Payment Approval Pending</Badge>;
  } else if (status === "DRAFT") {
    return <Badge bg="danger">Draft</Badge>;
  } else if (status === "RENEW") {
    return <Badge bg="success">Renew</Badge>;
  }
};

export default CommonStatus;
